import { Input } from "@chakra-ui/react";

export function TextComponent({ column, onChange, ...rest }) {
  return (
    <Input id={column.fieldName} onChange={onChange} {...rest} />
  )
}
